import { render, staticRenderFns } from "./TheLyoutFooter.vue?vue&type=template&id=33274b42&scoped=true&"
import script from "./TheLyoutFooter.vue?vue&type=script&lang=js&"
export * from "./TheLyoutFooter.vue?vue&type=script&lang=js&"
import style0 from "./TheLyoutFooter.vue?vue&type=style&index=0&id=33274b42&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33274b42",
  null
  
)

export default component.exports